// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 27,
  argument: "",
  verses: [
    { n: 1, text: "Boast not for to-morrow, for thou knowest not what the day to come may bring forth." },
    { n: 2, text: "Let another praise thee, and not thy own mouth: a stranger, and not thy own lips." },
    { n: 3, text: "A stone is heavy, and sand weighty: but the anger of a fool is heavier than them both." },
    { n: 4, text: "Anger hath no mercy: nor fury, when it breaketh forth: and who can bear the violence of one provoked?" },
    { n: 5, text: "Open rebuke is better than hidden love." },
    { n: 6, text: "Better are the wounds of a friend, than the deceitful kisses of an enemy." },
    { n: 7, text: "A soul that is full shall tread upon the honeycomb: and a soul that is hungry shall take even bitter for sweet." },
    { n: 8, text: "As a bird that wandereth from her nest, so is a man that leaveth his place." },
    { n: 9, text: "Ointment and perfumes rejoice the heart: and the good counsels of a friend are sweet to the soul." },
    { n: 10, text: "Thy own friend, and thy father's friend, forsake not: and go not into thy brother's house in the day of thy affliction. Better is a neighbour that is near, than a brother afar off." },
    { n: 11, text: "Study wisdom, my son, and make my heart joyful, that thou mayst give an answer to him that reproacheth." },
    { n: 12, text: "The prudent man seeing evil hideth himself: little ones passing on have suffered losses." },
    { n: 13, text: "Take away his garment that hath been surety for a stranger: and take from him a pledge for strangers." },
    { n: 14, text: "He that blesseth his neighbour with a loud voice, rising in the night, shall be like to him that curseth." },
    { n: 15, text: "Roofs dropping through in a cold day, and a contentious woman are alike." },
    { n: 16, text: "He that retaineth her, is as he that would hold the wind, and shall call in the oil of his right hand." },
    { n: 17, text: "Iron sharpeneth iron, so a man sharpeneth the countenance of his friend." },
    { n: 18, text: "He that keepeth the fig-tree, shall eat the fruit thereof: and he that is the keeper of his master, shall be glorified." },
    { n: 19, text: "As the faces of them that look therein, shine in the water, so the hearts of men are laid open to the wise." },
    { n: 20, text: "Hell and destruction are never filled: so the eyes of men are never satisfied." },
    { n: 21, text: "As silver is tried in the fining pot, and gold in the furnace: so a man is tried by the mouth of him that praiseth. The heart of the wicked seeketh after evils, but the righteous heart seeketh after knowledge." },
    { n: 22, text: "Though thou shouldst bray a fool in the mortar, as when a pestle striketh upon sodden barley, his folly would not be taken from him." },
    { n: 23, text: "Be diligent to know the countenance of thy cattle, and consider thy own flocks:" },
    { n: 24, text: "For thou shalt not always have power: but a crown shall be given to generation and generation." },
    { n: 25, text: "The meadows are open, and the green herbs have appeared, and the hay is gathered out of the mountains." },
    { n: 26, text: "Lambs are for thy clothing: and kids for the price of the field." },
    { n: 27, text: "Let the milk of the goats be enough for thy food, and for the necessities of thy house, and for maintenance for thy handmaids." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Lips. All hate affectation and vanity, John v. 51.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Both. He is insupportable to himself and to others, Ecclesiasticus xxii. 17.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "And who. Septuagint, \"but envy (zeal) beareth nothing.\" The more we yield to the envious, the more he is offended at our good behaviour.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Love. Which can be of no service to us, while reproof may cause us to amend.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Enemy. Joab slew Amasa, while he kissed him, 2 Kings xx. 9., and Matthew xxvi. 48. True friendship is not attentive to outward appearances.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Place, or vocation, like the prodigal son, Luke xv. The Israelites were much attached to their own country, where they might practise the true religion.", attribution: "Calmet" }
    ] },
    { verse: 9, notes: [
      { text: "And. Septuagint add, \"wine and incense....but accidents tear the soul.\"", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Affliction. He will be less compassionate than a tried friend. — Better, &c. This daily experience evinces. \"Those who purchase land, should consider if there be plenty of water, and a neighbour.\" (Pliny, [Natural History?] xviii. 5.) — The Persians honour most those who live nearest to them.", attribution: "Herodotus i. 134." }
    ] },
    { verse: 11, notes: [
      { text: "Thou. Hebrew, Complutensian, and Sixtus V, \"I may,\" &c. Septuagint, \"and cast reproaches from thee.\"", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "In the night. Or \"early in the morning,\" de nocte, as the Hebrew implies. — Curseth. His importunity will be equally displeasing. (Haydock) — Flattery is dangerous, (Calmet) and unworthy of a free man.", attribution: "Cicero, de Amic." }
    ] },
    { verse: 16, notes: [
      { text: "Hand. As it will flow away, such a woman is commonly incorrigible.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Sharpeneth. Or instructeth. Fungar vice cotis.", attribution: "Horace, Art." }
    ] },
    { verse: 18, notes: [
      { text: "Glorified. He who serves his master well shall be promoted.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Are. Hebrew, \"to men.\" Our hearts have all something similar. (Calmet) — Septuagint, \"as faces are not like each other, so neither are the hearts of men.\" They have all some peculiarity. (Haydock) — But this agrees not with the original.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Destruction. Hebrew abaddo, or abadon, chap. xv. 11., and Apocalypse ix. 11. People die, and are plunged in hell daily. — Eyes. Avarice and ambition, Ecclesiasticus xiv. 9.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Praiseth. If he be not puffed up, or if all agree in his praises, we may conclude that they are well founded. — The, &c., is not in Hebrew, Comp.[Complutensian?], St. Jerome, or Chaldean, and destroys the connection.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Mortar. Such were used by those who could not afford handmills.", attribution: "Calmet" }
    ] },
    { verse: 23, notes: [
      { text: "Flocks. John x. 3., and Ecclesiasticus vii. 24. This may be applied to pastors.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Generation. Thou wilt be cited as an example of prudence, if thou hast forseen the change of thy affairs, and provided for it. In the east it was not unusual to see a general of an army reduced to the meanest condition, and economy is necessary for all.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Field. If thou wishest to purchase, or to pay the workmen.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Milk. We cannot but admire such frugality. Septuagint are rather different", attribution: "Calmet" }
    ] },
    { verse: 25, notes: [
      { text: ", \"Be careful of the grass in thy field....that thou mayst have lambs for thy clothing. Honour the field, that there may be lambs for thee. (27) Son, thou hast from me solid instructions for thy life, and for that of thy servants.\"", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
